import { createFileRoute, Link } from "@tanstack/react-router";
import { Arrow } from "@/components/icons";
import { routeHead } from "@/components/seo";
import { pageMeta, testimonials, site } from "@/content";

const ROUTE = "/client-results";
export const Route = createFileRoute("/client-results")({
  head: () => routeHead(ROUTE),
  component: Page,
});
function Page() {
  const p = pageMeta(ROUTE)!;
  const [lead, ...rest] = testimonials;
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-line">
        <div className="mx-auto max-w-3xl px-6 py-20">
          <h1 className="hero-enter mt-4 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
            {p.h1}
          </h1>
          <p className="hero-enter-delay mt-6 max-w-2xl text-lg leading-relaxed text-ink/80">
            {p.description}
          </p>

          {lead && (
            <figure className="reveal mt-14 border-t border-line pt-10">
              <blockquote className="font-serif text-2xl leading-relaxed text-ink sm:text-3xl">
                &ldquo;{lead.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 text-sm">
                <span className="name-mark" aria-hidden />
                <span>
                  <span className="block font-semibold text-ink">{lead.name}</span>
                  <span className="block text-subtle">{lead.theme}</span>
                </span>
              </figcaption>
            </figure>
          )}

          <div className="stagger mt-14 grid gap-x-10 gap-y-10 border-t border-line pt-10 sm:grid-cols-2">
            {rest.map((t) => (
              <figure key={t.name} className="flex gap-3">
                <span className="name-mark shrink-0" aria-hidden />
                <div>
                  <blockquote className="leading-relaxed text-ink/85">
                    &ldquo;{t.quote}&rdquo;
                  </blockquote>
                  <figcaption className="mt-3 text-sm">
                    <span className="font-semibold text-ink">{t.name}</span>
                    <span className="text-subtle"> — {t.theme}</span>
                  </figcaption>
                </div>
              </figure>
            ))}
          </div>

          <div className="reveal mt-14 border-t border-line pt-10">
            <Link to={site.primaryCta.href} className="btn-primary">
              {site.primaryCta.label}
              <Arrow className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}
